import { toast } from "sonner";
import { useApi, useFetch, useMe, errMsg, fmtDate } from "../lib/api";
import { Btn, Card, Empty } from "./common";

const Bars = ({ rows, top, testid }) => (
  <div data-testid={testid}>{rows.map((r) => (
    <div key={r.key} className="mb-2">
      <div className="flex justify-between text-xs"><span className={top.includes(r.key) ? "font-semibold text-blue-700" : ""}>{r.key}{top.includes(r.key) && " · focus"}</span><span className="font-mono">{Math.round(r.score * 100)}</span></div>
      <div className="h-1.5 rounded bg-slate-100"><div className="h-1.5 rounded bg-blue-600" style={{ width: `${r.score * 100}%` }} /></div>
      <div className="text-[10px] text-slate-500">{r.why}</div>
    </div>))}</div>
);

export function FocusCard() {
  const api = useApi();
  const { isAdmin } = useMe();
  const { data, reload } = useFetch("/focus");
  const run = async () => { try { await api.post("/focus/recompute"); toast.success("Focus recalculated"); reload(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Card title={`Discovery focus${data?.at ? ` · ${fmtDate(data.at)}` : ""}`} className="mb-6" testid="focus-card"
      action={isAdmin && <Btn variant="ghost" className="h-8 text-xs" onClick={run} data-testid="focus-recompute">Recalculate now</Btn>}>
      {!data?.countries ? <Empty text="Not calculated yet. It updates every Monday, or click Recalculate now." testid="focus-empty" /> : <>
        <p className="mb-3 text-xs text-slate-600" data-testid="focus-summary">{data.enabled ? `${Math.round(data.share * 100)}% of Google searches and earlier AI review go to focus countries: ${data.top_countries.join(", ")}; technologies: ${data.top_technologies.join(", ")}. The rest keeps exploring.` : "Focus tuning is OFF (Settings → Discovery)."} Ranking = strong/medium lead potential, blended with reply rate once a country has enough emails sent.</p>
        <div className="grid gap-6 md:grid-cols-2"><Bars rows={data.countries} top={data.top_countries} testid="focus-countries" /><Bars rows={data.technologies} top={data.top_technologies} testid="focus-technologies" /></div>
      </>}
    </Card>
  );
}
